<template>
    <div>
        <v-dialog v-model="dialog" max-width="820px" @click:outside="hide" scrollable>
            <v-card tile>
                <v-card-title>
                    <v-icon color="black" left size="40">
                        {{ editMode ? 'mdi-file-document-edit-outline' : 'mdi-file-document-plus-outline' }}
                    </v-icon>
                    <div class="title-dialog">
                        Expense report (rendición de gasto): {{ code }}
                        <div class="title-subtext">
                            Completa los siguientes datos
                        </div>
                    </div>
                    <v-spacer />
                    <v-btn icon color="accent" large @click="hide">
                        <v-icon large>mdi-close-circle-outline</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <kimsa-date-picker label="Date (fecha)" placeholder="-- / -- / --" bolder-label outlined
                                solo flat dense force-value :value="date" @change="date = $event"
                                styleInput="max-width: 200px" />
                        </v-col>
                        <v-col cols="6">
                            <kimsa-text-field label="Exchange rate: USD$1 = X CLP or Pen (tipo de cambio)" bolder-label
                                outlined solo flat dense force-value :value="exchangeRate" inputMode="numeric"
                                allowDecimals disableDots @change="exchangeRate = $event"
                                styleInput="max-width: 200px; margin-left: auto" />
                        </v-col>
                        <v-col cols="12">
                            <kimsa-textarea-field label="Description (Descripción)" bolder-label rows="2" outlined dense
                                force-value :value="description" @change="description = $event" />
                        </v-col>
                        <v-col cols="12" class="bank-section">
                            Bank account detail for reimbursement: <small>(Datos cuenta corriente del solicitante para
                                reembolso)</small>
                        </v-col>
                        <v-col cols="6">
                            <kimsa-text-field label="Bank (banco)" bolder-label outlined solo flat dense force-value
                                :value="account_bank_name" @change="account_bank_name = $event" />
                        </v-col>
                        <v-col cols="6">
                            <kimsa-text-field label="Account number (numero de cuenta)" bolder-label outlined dense
                                force-value :value="account_number" @change="account_number = $event"
                                inputMode="numeric" disableDots />
                        </v-col>
                        <v-col cols="6">
                            <kimsa-text-field label="EIN/RUT/RUC ( tax id.)" bolder-label outlined solo flat dense
                                force-value :value="account_rut" @change="account_rut = $event" />
                        </v-col>
                        <v-col cols="6">
                            <kimsa-text-field label="Email" bolder-label outlined dense force-value inputMode="email"
                                :value="account_email" @change="account_email = $event" />
                        </v-col>
                        <v-col cols="12" align="center">
                            <v-btn @click="editMode ? editExpenseReport() : saveExpenseReport()" tile color="primary"
                                depressed :disabled="!valid" :loading="loading">
                                SAVE
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <expense-report-tips-dialog ref="tips" @hide="onShowDialog" />
    </div>
</template>

<script>

import { mapMutations, mapState } from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import Axios from "@/utils/Axios";
import KimsaTextareaField from '@/components/common/inputs/KimsaTextareaField.vue';
import KimsaDatePicker from '../inputs/KimsaDatePicker.vue';
import { getNameInitials } from "../../../utils/Common";
import ExpenseReportTipsDialog from './ExpenseReportTipsDialog.vue';

export default {
    name: "CreateExpenseReportUserDialog",
    components: { KimsaTextField, KimsaTextareaField, KimsaDatePicker, ExpenseReportTipsDialog },
    data() {
        return {
            dialog: false,
            loading: false,
            editMode: false,
            expenseReport: null,
            clientId: null,
            date: this.$moment().format('YYYY-MM-DD'),
            description: '',
            exchangeRate: '',
            account_bank_name: '',
            account_number: '',
            account_rut: '',
            account_email: '',
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            return !!vm.date && !!vm.description && !!vm.exchangeRate && !!vm.account_bank_name && !!vm.account_number && !!vm.account_rut && vm.validEmail(vm.account_email)
        },
        code(vm = this) {
            return getNameInitials(vm.account?.name) + vm.$moment(vm.date).format('DDMMYYYY')
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show(clientId = null) {
            const vm = this
            if (clientId) vm.clientId = clientId
            vm.$refs.tips.show()
        },
        onShowDialog() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.expenseReport = null
            vm.clientId = null
            vm.date = vm.$moment().format('YYYY-MM-DD')
            vm.description = ''
            vm.exchangeRate = ''
            vm.account_bank_name = ''
            vm.account_number = ''
            vm.account_rut = ''
            vm.account_email = ''
        },
        async loadExpenseReport(id) {
            const vm = this
            await Axios.get(`expense-reports/${id}`).then(res => {
                // console.log('res loadExpenseReport', res)
                vm.expenseReport = res.data.result.expenseReport
                vm.editMode = true
                vm.clientId = vm.expenseReport.client_id
                vm.description = vm.expenseReport.description
                vm.date = vm.$moment(vm.expenseReport.date).format('YYYY-MM-DD')
                vm.exchangeRate = vm.expenseReport.exchange_rate
                vm.account_bank_name = vm.expenseReport.account_bank_name
                vm.account_number = vm.expenseReport.account_number
                vm.account_rut = vm.expenseReport.account_rut
                vm.account_email = vm.expenseReport.account_email
                vm.show()
            }).catch(er => {
                console.log('error loadExpenseReport', er)
            })
        },
        async saveExpenseReport() {
            const vm = this
            vm.loading = true
            // console.log('saveExpenseReport', vm)

            let payload = {
                client_id: vm.clientId,
                user_id: vm.account.id,
                code: vm.code,
                description: vm.description,
                date: vm.date,
                exchange_rate: parseFloat(vm.exchangeRate),
                account_bank_name: vm.account_bank_name,
                account_number: vm.account_number + '',
                account_rut: vm.account_rut,
                account_email: vm.account_email
            }

            // console.log('payload', payload)

            await Axios.post('expense-reports/new', payload).then(res => {
                // console.log('res saveExpenseReport',res)
                vm.toast('Rendición de gastos creado')
                vm.$emit('success')
                vm.hide()
            }).catch(error => {
                console.log('error saveExpenseReport', error)
                vm.toast('Ha ocurrido un error', 'error')
            }).finally(() => {
                vm.loading = false
            })
        },
        async editExpenseReport() {
            const vm = this
            vm.loading = true

            // console.log('editExpenseReport', vm)

            let payload = {
                client_id: vm.clientId,
                user_id: vm.expenseReport.user_id,
                code: vm.code,
                description: vm.description,
                date: vm.date,
                exchange_rate: vm.exchangeRate,
                account_bank_name: vm.account_bank_name,
                account_number: vm.account_number,
                account_rut: vm.account_rut,
                account_email: vm.account_email
            }

            // console.log('payload', payload)

            await Axios.patch(`expense-reports/${vm.expenseReport.id}/edit`, payload).then(res => {
                // console.log('res editExpenseReport',res)
                vm.toast('Rendición de gastos editado')
                vm.$emit('success')
                vm.hide()
            }).catch(error => {
                console.log('error editExpenseReport', error)
                vm.toast('Ha ocurrido un error', 'error')
            }).finally(() => {
                vm.loading = false
            })
        },
        validEmail(email) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(email) || false
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.label {
    font-size: 15px;
    color: #333333;
}

.bank-section {
    font-size: 20px;
    font-weight: bold;
    color: #000000;
}
</style>